<template>
  <div id="app" >
    <router-view /> <!-- This renders the component for the current route -->
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    document.title = 'Login V2'
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
